import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-user.copy-shared-accounts', {
        url: '/copy-shared-accounts',
        params: {accounts: []},
        component: 'companyUserDirectoriesManageUserCopySharedAccounts',
        resolve: {
            accounts,
        },
    });
}

/** @ngInject */
function accounts($stateParams) {
    return $stateParams.accounts;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/copy-shared-accounts/copy-shared-accounts.state.js